import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth, landingPath } from "@/context/AuthContext";
import { BranchProvider } from "@/context/BranchContext";
import { PermissionsProvider } from "@/context/PermissionsContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import AppLayout from "@/components/AppLayout";

import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import POS from "@/pages/POS";
import Sales from "@/pages/Sales";
import Shifts from "@/pages/Shifts";
import CashDeposits from "@/pages/CashDeposits";
import Receivables from "@/pages/Receivables";
import Products from "@/pages/Products";
import Stock from "@/pages/Stock";
import OpnameBulk from "@/pages/OpnameBulk";
import Purchasing from "@/pages/Purchasing";
import Transfer from "@/pages/Transfer";
import Suppliers from "@/pages/Suppliers";
import Customers from "@/pages/Customers";
import Reports from "@/pages/Reports";
import Users from "@/pages/Users";
import Branches from "@/pages/Branches";
import AuditLog from "@/pages/AuditLog";
import FoodOrders from "@/pages/FoodOrders";
import PurchaseOrders from "@/pages/PurchaseOrders";
import CashierReport from "@/pages/CashierReport";
import MenuAccess from "@/pages/MenuAccess";
import ResetData from "@/pages/ResetData";
import InitialStock from "@/pages/InitialStock";
import Categories from "@/pages/Categories";
import RegionPrices from "@/pages/RegionPrices";
import SpecialSales from "@/pages/SpecialSales";

const page = (el, roles) => (
  <ProtectedRoute roles={roles}>
    <BranchProvider>
      <AppLayout>{el}</AppLayout>
    </BranchProvider>
  </ProtectedRoute>
);

function HomeRedirect() {
  const { user } = useAuth();
  return <Navigate to={landingPath(user.role)} replace />;
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <PermissionsProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/" element={<ProtectedRoute><HomeRedirect /></ProtectedRoute>} />
              <Route path="/dashboard" element={page(<Dashboard />, ["super_admin", "admin", "branch_head", "financial"])} />
              <Route path="/pos" element={page(<POS />, ["super_admin", "admin", "branch_head", "cashier"])} />
              <Route path="/penjualan" element={page(<Sales />, ["super_admin", "admin", "branch_head", "cashier"])} />
              <Route path="/penjualan-khusus" element={page(<SpecialSales />, ["super_admin", "admin"])} />
              <Route path="/shift" element={page(<Shifts />, ["super_admin", "admin", "branch_head", "cashier"])} />
              <Route path="/setoran" element={page(<CashDeposits />, ["super_admin", "admin", "branch_head"])} />
              <Route path="/piutang" element={page(<Receivables />, ["super_admin", "admin"])} />
              <Route path="/produk" element={page(<Products />, ["super_admin", "admin", "branch_head"])} />
              <Route path="/kategori" element={page(<Categories />, ["super_admin", "admin", "branch_head"])} />
              <Route path="/harga-region" element={page(<RegionPrices />, ["super_admin", "admin"])} />
              <Route path="/stok" element={page(<Stock />, ["super_admin", "admin", "branch_head", "warehouse"])} />
              <Route path="/opname" element={page(<OpnameBulk />, ["super_admin", "admin", "branch_head", "warehouse"])} />
              <Route path="/stok-awal" element={page(<InitialStock />, ["super_admin", "admin", "branch_head", "warehouse"])} />
              <Route path="/pembelian" element={page(<Purchasing />, ["super_admin", "admin", "branch_head", "warehouse"])} />
              <Route path="/transfer" element={page(<Transfer />, ["super_admin", "admin", "branch_head", "warehouse"])} />
              <Route path="/supplier" element={page(<Suppliers />, ["super_admin", "admin", "branch_head", "warehouse"])} />
              <Route path="/pelanggan" element={page(<Customers />, ["super_admin", "admin", "branch_head"])} />
              <Route path="/laporan" element={page(<Reports />, ["super_admin", "admin", "branch_head", "financial"])} />
              <Route path="/pengguna" element={page(<Users />, ["super_admin", "admin", "branch_head"])} />
              <Route path="/hak-akses" element={page(<MenuAccess />, ["super_admin"])} />
              <Route path="/reset" element={page(<ResetData />, ["super_admin"])} />
              <Route path="/cabang" element={page(<Branches />, ["super_admin", "admin"])} />
              <Route path="/audit" element={page(<AuditLog />, ["super_admin", "admin", "branch_head"])} />
              <Route path="/pesanan" element={page(<FoodOrders />, ["reseller", "super_admin", "admin", "branch_head", "cashier"])} />
              <Route path="/po" element={page(<PurchaseOrders />, ["super_admin", "admin", "branch_head", "warehouse"])} />
              <Route path="/laporan-kasir" element={page(<CashierReport />, ["cashier", "super_admin", "admin", "branch_head"])} />
            </Routes>
          </BrowserRouter>
        </PermissionsProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
